var _style, _desc, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusGreenCircleIco(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill:#7BCB45;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M7.5,0C3.4,0,0,3.4,0,7.5S3.4,15,7.5,15S15,11.6,15,7.5S11.6,0,7.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "st1",
    d: "M8.2,6.7l0.1-3.1c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.2-0.6,0.5L7.1,6.7L3.8,6.6 c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.2,0.5,0.5,0.5l3.3,0.1l-0.1,3.1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.6-0.2,0.6-0.5l0.1-3.1l3.3,0.1 c0.3,0,0.6-0.2,0.6-0.5c0-0.3-0.2-0.5-0.5-0.5L8.2,6.7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreenCircleIco);
export default __webpack_public_path__ + "static/media/plus-green-circle-ico.72fbfed35b7d0fec0ee8a58b087b79ef.svg";
export { ForwardRef as ReactComponent };